import PixiLayer from '__editor/googleMapsRoofsSelector/pixiLayer';
import { getMap } from '__editor/googleMapsRoofsSelector/components/map/map';
import { advanceRoofSelectingMove, advanceRoofSelectingClick } from '__common/components/advancedSelecting/advancedSelectingEvents';
import { renderRoofSnapHover } from '__editor/googleMapsRoofsSelector/components/advanceRoofSelecting/advanceRoofSelecting';
import { measurementToolClick, measurementToolMove } from '__common/components/measurementTool/measurementToolEvents';
let pixiLayer;

export function initPixi() {
  const map = getMap();
  pixiLayer = new PixiLayer(map, {});
  if (pixiLayer.stage) {
    pixiLayer.stage.on('mousemove', (event) => onMouseMove(event));
    pixiLayer.stage.on('touchmove', (event) => onMouseMove(event));
    pixiLayer.stage.on('mousedown', (event) => mapOnClickEvent(event));
    pixiLayer.stage.on('touchstart', (event) => mapOnClickEvent(event));
    pixiLayer.stage.on('touchend', (event) => mapOnClickEvent(event));
  }
  return pixiLayer;
}

function onMouseMove(event) {
  if (pixiLayer && pixiLayer.renderer && pixiLayer.stage) {
    advanceRoofSelectingMove(pixiLayer.renderer, pixiLayer.stage, event);
    renderRoofSnapHover(pixiLayer.renderer, pixiLayer.stage, event);
    measurementToolMove(pixiLayer.renderer, pixiLayer.stage, event);
  }
}

function mapOnClickEvent(event) {
  if (pixiLayer && pixiLayer.renderer && pixiLayer.stage) {
    advanceRoofSelectingClick(pixiLayer.renderer, pixiLayer.stage, event);
    measurementToolClick(pixiLayer.renderer, pixiLayer.stage, event);
  }
}


export function getPixiLayer(): PixiLayer {
  if (pixiLayer && pixiLayer.renderer && !pixiLayer.renderer.destroyed) {
    return pixiLayer;
  }
}

export function clearPixiLayer() {
  if (pixiLayer) {
    try {
      // Use the improved destroy method from PixiLayer
      pixiLayer.destroy();
    } catch (error) {
      console.warn('Error clearing PIXI layer:', error);
    } finally {
      pixiLayer = null;
    }
  }
}
